// CustomerReviews.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// const reviewsData = [
//   {
//     customer: "SOWMIYAA V.S",
//     rating: 5,
//     review: "On time delivery, nice package & good customer satisfaction🤩🤩",
//     date: "May 2, 2025",
//   },
//   {
//     customer: "Nandhini",
//     rating: 5,
//     review: "Wonderful dedication, instant response and prompt delivery..Good quality products..",
//     date: "April 11, 2025",
//   },
//   {
//     customer: "Lakshmi Ramanathan",
//     rating: 5,
//     review: "Very professional and helpful. Guided with a variety of options and always responded promptly. The products I received were also good, exactly as described. Highly recommend A3 Creative Hub for their quality and customer service!",
//     date: "April 4, 2025",
//   },
//   {
//     customer: "Anitha Manoharan",
//     rating: 5,
//     review: "Bought return gifts from abhinaya for my kids first bday. Ordered London bus pouch with pencil, pen, rubber, sharpener and highlighter packed so well in a gift bag. She made sure the gifts are packed nicely and it was in an affordable price range. Very happy in this deal. Recommending A3 Creative for creative and innovative return gifts in an affordable price range. The kids absolutely loved them!",
//     date: "November 1, 2024",
//   },
//   {
//     customer: "Kannan Natarajan",
//     rating: 5,
//     review: "Very well organised by A3 Creative Hub team. Cheers to them.",
//     date: "October 25, 2024",
//   },
//   {
//     customer: "Sridevi S",
//     rating: 5,
//     review: "Awesome return gift and liked by all kids… superb quality with various collections 🫶 100% love, care and customer satisfaction makes us buy more n more! Highly recommendable ❤️. Will definitely order again for future events.",
//     date: "September 27, 2024",
//   },
//   {
//     customer: "Vijayalakshmi Venkatesh",
//     rating: 5,
//     review: "", // Empty review text to demonstrate variable height
//     date: "September 13, 2024",
//   },
//   {
//     customer: "Viji Ramakrishnan",
//     rating: 5,
//     review: "", // Empty review text to demonstrate variable height
//     date: "September 6, 2024",
//   },
//   {
//     customer: "HEMA RAVIKRISHNAN",
//     rating: 5,
//     review: "Excellent Products & Price is also Affordable.",
//     date: "September 6, 2024",
//   },
//   {
//     customer: "Ajay Ramakrishnan",
//     rating: 5,
//     review: "Good products at reasonable price with very much good quality.",
//     date: "September 6, 2024",
//   },
//   {
//     customer: "Vaidyanathan Rangarajan",
//     rating: 5,
//     review: "Nice and good quality Products. Very Reasonable Price.",
//     date: "September 6, 2024",
//   },
//   {
//     customer: "Lokesh G",
//     rating: 5,
//     review: "Products are very affordable... Also a good quality...",
//     date: "September 6, 2024",
//   },
// ];

const StarRating = ({ rating }) => {
  const roundedRating = Math.round(rating);
  return (
    <div className="flex flex-nowrap text-yellow-400 mb-2 w-[110px]">
      {[...Array(5)].map((_, i) => (
        <svg
          key={i}
          className={`w-5 h-5 ${i < roundedRating ? 'fill-current' : 'fill-gray-300'}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z" />
        </svg>
      ))}
    </div>
  );
};

const CustomerReviews = () => {
  const [reviewsData, setReviewsData] = useState([]);
  const [currentReviewPage, setCurrentReviewPage] = useState(0);
  const [reviewsPerPage, setReviewsPerPage] = useState(1); // Default to 1 for mobile

  const fetchReviews = async () => {
    try {
      const response = await fetch("https://a3creativehub.in/api/reviews"); // Your backend endpoint
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json(); // <-- Parse JSON from response
      if (Array.isArray(data)) {
        setReviewsData(data); // <-- Set state with actual array
      } else {
        console.error("Reviews response is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching customer reviews:", error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const totalReviews = reviewsData.length;

  // Effect to determine reviewsPerPage based on screen width
  useEffect(() => {
    const handleResize = () => {
      // You can adjust the breakpoint (e.g., 768 for md or 1024 for lg)
      // based on your Tailwind CSS configuration
      if (window.innerWidth >= 1024) { // Desktop/Laptop
        setReviewsPerPage(2);
      } else { // Mobile
        setReviewsPerPage(1);
      }
      // Reset current page to avoid issues if page count changes due to reviewsPerPage change
      setCurrentReviewPage(0);
    };

    // Set initial value
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Run once on mount and on resize

  useEffect(() => {
    const totalPages = Math.ceil(reviewsData.length / reviewsPerPage);

    if (totalPages <= 1) {
      setCurrentReviewPage(0);
      return;
    }

    const reviewPaginationInterval = setInterval(() => {
      setCurrentReviewPage((prevPage) => (prevPage + 1) % totalPages);
    }, 5000);

    return () => clearInterval(reviewPaginationInterval);
    // eslint-disable-next-line
  }, [reviewsPerPage, reviewsData.length]); // Re-run effect if reviewsPerPage changes

  const startIndex = currentReviewPage * reviewsPerPage;
  const reviewsToDisplay = reviewsData.slice(startIndex, startIndex + reviewsPerPage);

  // Framer Motion Variants
  const headingVariants = {
    hidden: { opacity: 0, scale: 0.8, y: -20 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  const reviewCardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const summaryCardVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  return (
    <section id="reviews" className="bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 py-16 scroll-mt-16">
      <motion.h2
        className="text-4xl font-bold text-center text-pink-700 mb-12"
        variants={headingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.5 }}
      >
        Customer Reviews
      </motion.h2>

      <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-16 mb-12 max-w-screen-2xl mx-auto px-4">
        {/* Reviews Summary Section (Left Side) */}
        <motion.div
          className="flex flex-col items-center lg:items-start gap-8 w-full lg:w-1/2 p-6 bg-white rounded-lg shadow-md border border-yellow-200"
          variants={summaryCardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
        >
          <div className="flex flex-col items-center lg:items-start">
            <p className="text-5xl font-bold text-pink-600 mb-2">
              {(totalReviews > 0
                ? (Object.entries(
                    reviewsData.reduce((acc, review) => {
                      acc[review.rating]++;
                      return acc;
                    }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 })
                  ).reduce((sum, [rating, count]) => sum + (parseInt(rating) * count), 0) / totalReviews)
                : 0
              ).toFixed(1)}
            </p>
            <StarRating
              rating={
                totalReviews > 0
                  ? (Object.entries(
                      reviewsData.reduce((acc, review) => {
                        acc[review.rating]++;
                        return acc;
                      }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 })
                    ).reduce((sum, [rating, count]) => sum + (parseInt(rating) * count), 0) / totalReviews)
                  : 0
              }
            />
            <p className="text-gray-600 mt-1">{totalReviews} total reviews</p>
          </div>

          <div className="w-full">
            {[5, 4, 3, 2, 1].map((star) => {
              const count = reviewsData.filter(review => review.rating === star).length;
              const percentage = totalReviews > 0 ? (count / totalReviews) * 100 : 0;
              return (
                <div key={star} className="flex items-center mb-2">
                  <span className="font-semibold text-gray-700 w-8">{star} <span className="hidden sm:inline">★</span></span>
                  <div className="w-full bg-gray-200 rounded-full h-3 mx-2">
                    <div
                      className="bg-yellow-400 h-3 rounded-full"
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                  <span className="text-gray-600 text-sm w-10 text-right">{count}</span>
                </div>
              );
            })}
          </div>
        </motion.div>

        {/* Reviews Carousel Area (Right Side) */}
        <div className="flex justify-center w-full lg:w-1/2">
          <div
            className="relative overflow-hidden w-full transition-all duration-700 ease-in-out"
            style={{
              height: '1000px', // Fixed height to prevent layout shifts
            }}
          >
            {/* The grid should adapt to reviewsPerPage implicitly, but explicitly setting cols for LG */}
            <div className={`grid ${reviewsPerPage === 2 ? 'lg:grid-cols-2' : 'grid-cols-1'} gap-12 w-full h-full items-start`}>
              {reviewsToDisplay.map((review, index) => (
                <motion.div
                  key={index}
                  className="bg-white p-8 rounded-lg shadow-lg border border-yellow-200 flex flex-col justify-between w-full"
                  style={{ minHeight: '160px' }}
                  variants={reviewCardVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.5 }}
                >
                  <StarRating rating={review.rating} />
                  <p className="text-gray-700 text-lg mb-4 flex-grow">
                    {review.review || ""}
                  </p>
                  <div>
                    <p className="font-semibold text-pink-600">{review.customer}</p>
                    <p className="text-gray-500 text-sm">{review.date}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;